/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {CouponApiService} from './coupon-api.service';
import {FormsModule} from '@angular/forms';
import {APP_SHARED} from '../../common/app-shared';

export interface CouponCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-coupon-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy' | ogTranslate }} Coupon</span>
          <small>{{originalName}}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">Name</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="coupon.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Description</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="coupon.description" [(ngModel)]="description">
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Coupon Code</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="coupon.code" [(ngModel)]="code" required>
          </div>
        </div>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="coupon.destination">
            <span class="small">Go to new coupon after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class CouponCopyModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  model: any;

  readonly onCopied = new Subject<CouponCopyResult>();

  originalName = '';
  name = '';
  description = '';
  code = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly api: CouponApiService
  ) {}

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
    // Copies must get a new code before submission.
    this.code = '';
  }

  copy(): void {
    const coupon = _.cloneDeep({...this.model,
      id: Uuid.generate(),
      name: this.name,
      description: this.description,
      code: this.code
    });
    this.api.save(coupon).subscribe((saved) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
